module.exports = __webpack_public_path__ + "img/finished.b8cb4540.svg";